import React from "react";

import DamageForms from "../forms";
import { FilterModalStandard } from "components/service";

const DamageFilterModal = (props) => {
    return (
        <FilterModalStandard
            wrapClass="damage-filter-modal-wrap"
            modalClass="damage-filter-modal"
        >
            <DamageForms.Filter { ...props } />
        </FilterModalStandard>
    );
};

export default DamageFilterModal;
